module.exports = require("request");


//////////////////
// WEBPACK FOOTER
// external "request"
// module id = 9
// module chunks = 0